import React from 'react';
import {connect} from 'react-redux';

import {hasEntityPermission} from 'utils/permissions';

import {selectCurrentUserPermissions} from 'ducks/auth';

/*
  Used in cases where we want to hide/show something if the user has or doesn't have a certain permission
  
  ```
    <VisibleIf permission="viewBooking">
      <BookingsList />
    </VisibleIf>

    <VisibleIf not permission="viewBooking">
      <div>You have no permission to view bookings</div>
    </VisibleIf>
  ```
*/

class VisibleIf extends React.Component<any> {
  render() {
    const {
      children,
      not,
      userPermissions,
      permission,
      locationRef
    } = this.props;

    const hasPermission = hasEntityPermission({
      userPermissions,
      permission,
      locationRef
    });

    // user has no permission and "not" is false
    if (!hasPermission && !not) {
      return null;
    }

    // user has permission but "not" is true
    if (hasPermission && !!not) {
      return null;
    }

    return children;
  }
}

const mapStateToProps = state => {
  return {userPermissions: selectCurrentUserPermissions(state)};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VisibleIf);
